export type WebtoonStoryMeta = {
  id: number;
  title: string;
  subtitle: string;
};

export const WEBTOON_STORIES: WebtoonStoryMeta[] = [
  {
    id: 8211981,
    title: '⛤ 밴드부에서 나만 여자',
    subtitle: '착각하지마, 널 좋아하게 될 일 없으니까.',
  },
  {
    id: 9298418,
    title: '그 사대천왕의 장난감입니다.',
    subtitle: '"사귈 마음따위 없어 가지고 노는거지"',
  },
  {
    id: 8161212,
    title: '짖어봐, 더 망가지도록',
    subtitle: '“강아지, 네 이름답게 개처럼 굴어야지.”',
  },
  {
    id: 9749352,
    title: '중삐리 보스 길들이기',
    subtitle: '난 아직 이 세상이 두려워, 강이음.',
  },
  {
    id: 4902111,
    title: '더 무너져봐, 나한테 [완]',
    subtitle: '“말했잖아, 네 목숨은 내 거라고.”',
  },
];

const WEBTOON_FULL_LIST_ENVS = ['production', 'staging', 'dev'];

export const WEBTOON_STORY_TOON_IDS =
  WEBTOON_FULL_LIST_ENVS.includes(process.env.NEXT_PUBLIC_ENV ?? '')
    ? [1, 2, 3, 4, 5, 6]
    : [1, 2, 3];
export const WEBTOON_EPISODE_LIST_LIMIT = 200;
